// 1 - MOBILE
// 2 - DESKTOP
import view from '../../Enums';
import * as IMAGES from '../../Images';
import { makeStyle } from '../../utils';
import { black, bold, button, h5, h6, rowCenter, subTitle1 } from '../../resources/styles';
import styles from '../Static/PartnerProsperity/styles';

let commonStyle, key;
var LandingStyles = {};
var vertCenterAbs = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};
var horiCenterAbs = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)'
};

var centerAbs = {
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translateY(-50%) translateX(-50%)'
};

// example of setting stype
LandingStyles[''] = {};
LandingStyles[''][view.MOBILE] = {};
LandingStyles[''][view.DESKTOP] = {};

// Know More Modal
LandingStyles['parentKnowMore'] = {};
LandingStyles['parentKnowMore'][view.MOBILE] = {
  ...horiCenterAbs,
  width: '96%',
  top: '10%',
  backgroundColor: 'white',
  width: '75%',
  textAlign: 'center',
  padding: '24px 34px',
  outline: 'none'
};
LandingStyles['parentKnowMore'][view.DESKTOP] = {
  ...horiCenterAbs,
  top: '17%',
  height: '500px',
  outline: 'none',
  // backgroundColor: 'white',
  width: '50%',
  textAlign: 'center',
  padding: '0px 48px'
};

LandingStyles['subKnowMore'] = {};
LandingStyles['subKnowMore'][view.DESKTOP] = {
  ...horiCenterAbs,
  top: '12%',
  // minHeight: '400px',
  backgroundColor: 'white',
  outline: 'none',
  width: '65%',
  textAlign: 'center',
  padding: '0px 48px 48px'
};

LandingStyles['headingStyles'] = {};
LandingStyles['headingStyles'][view.DESKTOP] = {
  color: 'white',
  opacity: '0.7',
  fontWeight: 600,
  margin: '10px',
  cursor: 'pointer'
};
LandingStyles['headingStylesSelected'] = {};
LandingStyles['headingStylesSelected'][view.DESKTOP] = {
  color: 'white',
  fontWeight: 600,
  margin: '10px',
  cursor: 'pointer'
};

LandingStyles['parentKnowMoreHeading'] = {};
LandingStyles['parentKnowMoreHeading'][view.DESKTOP] = {
  ...horiCenterAbs,
  display: 'flex',
  left: '50%',
  width: '100%',
  justifyContent: 'center',
  padding: '0px 48px'
};

LandingStyles['parentKnowMoreHeadingSelected'] = {};
LandingStyles['parentKnowMoreHeadingSelected'][view.DESKTOP] = {
  height: '4px',
  backgroundColor: 'white',
  borderRadius: '2px'
};

LandingStyles['imgKnowMore'] = {};
LandingStyles['imgKnowMore'][view.MOBILE] = {
  height: '138px',
  width: '138px',
  marginTop: '48px',
  marginBottom: '16px'
};
LandingStyles['imgKnowMore'][view.DESKTOP] = {
  height: '138px',
  width: '138px',
  marginTop: '48px',
  marginBottom: '16px'
};

LandingStyles['headKnowMore'] = {};
LandingStyles['headKnowMore'][view.MOBILE] = {
  fontFamily: 'InterphaseBold',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  marginBottom: '10px'
};
LandingStyles['headKnowMore'][view.DESKTOP] = {
  fontFamily: 'InterphaseBold',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};

LandingStyles['contentKnowMore'] = {};
LandingStyles['contentKnowMore'][view.MOBILE] = {
  marginTop: '8px',
  opacity: '0.54',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};
LandingStyles['contentKnowMore'][view.DESKTOP] = {
  marginTop: '8px',
  opacity: '0.54',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};

// Become an Oyo Form

LandingStyles['oyo_form_container'] = {};
LandingStyles['oyo_form_container'][view.MOBILE] = {
  ...horiCenterAbs,
  zIndex: '50',
  width: '328px',
  borderRadius: '8px',
  boxShadow: '0 3px 4px 0 rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  position: 'absolute',
  transform: 'translateY(-218.5px) translateX(-50%)'
  // top: '550px'
};
LandingStyles['oyo_form_container'][view.DESKTOP] = {
  zIndex: '50',
  width: '396px',
  borderRadius: '8px',
  boxShadow: '0 3px 4px 0 rgba(157, 157, 157, 0.14)',
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  position: 'absolute'
};

LandingStyles['become_oyo_style'] = {};
LandingStyles['become_oyo_style'][view.MOBILE] = {
  marginBottom: '4px',
  width: '100%',
  height: '24px',
  opacity: '0.87',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000'
};
LandingStyles['become_oyo_style'][view.DESKTOP] = {
  fontSize: '20px',
  marginBottom: '4px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '-0.23px',
  color: '#222222',
  marginTop: '15px'
};

LandingStyles['privacy_policy_style'] = {};
LandingStyles['privacy_policy_style'][view.MOBILE] = {
  // marginTop: '25px',
  position: 'absolute',
  marginTop: '40px',
  textAlign: 'center',
  color: 'black',
  bottom: '-18px'
};
LandingStyles['privacy_policy_style'][view.DESKTOP] = {
  textAlign: 'center',
  color: 'white',
  bottom: '-3px'
};

LandingStyles['complete_div_style'] = {};
commonStyle = {
  width:"100%",
  height:'100%',
  overflow:'scroll',
  position:'relative'
}
LandingStyles['complete_div_style'][view.MOBILE] = {
  ...commonStyle
};
LandingStyles['complete_div_style'][view.DESKTOP] = {
  ...commonStyle
};
LandingStyles['main_form_style'] = {};
LandingStyles['main_form_style'][view.MOBILE] = {
  width: '85%',
  margin: '20px auto'
};
LandingStyles['main_form_style'][view.DESKTOP] = {
  width: '85%',
  margin: '0px auto',
  position: 'relative'
};

LandingStyles['join_us_btn'] = {};
LandingStyles['join_us_btn'][view.MOBILE] = {
  width: '100%',
  height: '44px',
  borderRadius: '4px',
  border: '0',
  boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
  backgroundColor: '#1ab64f',
  marginRight: '20px',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  textTransform: 'uppercase'
};
LandingStyles['join_us_btn'][view.DESKTOP] = {
  width: '100%',
  height: '44px',
  borderRadius: '4px',
  border: '0',
  boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
  backgroundColor: '#1ab64f',
  marginRight: '20px',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.14',
  textTransform: 'uppercase'
};

LandingStyles['flag_style'] = {};
LandingStyles['flag_style'][view.MOBILE] = {
  top: '13px',
  width: '24px',
  height: '14.6px',
  backgroundImage: 'url(' + IMAGES.FLAGS + ')',
  backgroundPosition: '100 100',
  backgroundSize: 'cover',
  position: 'relative',
  zIndex: '2',
  display: 'inline-block',
  cursor: 'pointer'
};
LandingStyles['flag_style'][view.DESKTOP] = {
  top: '13px',
  width: '24px',
  height: '14.6px',
  backgroundImage: 'url(' + IMAGES.FLAGS + ')',
  backgroundPosition: '100 100',
  backgroundSize: 'cover',
  position: 'relative',
  zIndex: '2',
  display: 'inline-block',
  cursor: 'pointer'
};

LandingStyles['mobile_number_container'] = {};
LandingStyles['mobile_number_container'][view.MOBILE] = {
  width: '92%',
  position: 'relative'
};
LandingStyles['mobile_number_container'][view.DESKTOP] = {
  position: 'relative'
};

LandingStyles['cursor_pointer_style'] = {};
LandingStyles['cursor_pointer_style'][view.MOBILE] = {
  position: 'absolute',
  top: '16px',
  left: '46px'
};
LandingStyles['cursor_pointer_style'][view.DESKTOP] = {
  position: 'absolute',
  top: '16px',
  left: '46px'
};

LandingStyles['down_arrow_style'] = {};
LandingStyles['down_arrow_style'][view.MOBILE] = {
  height: '10px',
  width: '12px'
};
LandingStyles['down_arrow_style'][view.DESKTOP] = {
  height: '10px',
  width: '12px'
};

LandingStyles['flag_image_style'] = {};
LandingStyles['flag_image_style'][view.MOBILE] = {
  position: 'absolute',
  top: '19.5px',
  left: '18px'
};
LandingStyles['flag_image_style'][view.DESKTOP] = {
  position: 'absolute',
  top: '19.5px',
  left: '18px'
};

LandingStyles['location_container'] = {};
LandingStyles['location_container'][view.MOBILE] = {
  position: 'relative'
};
LandingStyles['location_container'][view.DESKTOP] = {
  position: 'relative'
};

LandingStyles['form_small_text'] = {};
LandingStyles['form_small_text'][view.MOBILE] = {
  height: '24px',
  opacity: '0.54',
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#222222'
};
LandingStyles['form_small_text'][view.DESKTOP] = {
  fontSize: '12px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '2',
  letterSpacing: 'normal',
  color: '#888'
};

/////////////////////////////////////////////////////////////////////////not working
LandingStyles['selection_card_style'] = {};
LandingStyles['selection_card_style'][view.MOBILE] = {
  width: '48%',
  height: '56px'
};
LandingStyles['selection_card_style'][view.DESKTOP] = {
  width: '48%',
  height: '56px'
};
///////////////////////////////////////////////////////////////////////not working

LandingStyles['mobile_width_style'] = {};
LandingStyles['mobile_width_style'][view.MOBILE] = {
  width: '70%'
};
LandingStyles['mobile_width_style'][view.DESKTOP] = {
  width: '83%'
};

LandingStyles['input_form'] = {};
LandingStyles['input_form'][view.MOBILE] = {
  borderRadius: '2px',
  border: 'solid 1px rgba(0, 0, 0, 0.08)',
  padding: '10px 0px 10px 16px',
  width: '95%',
  marginBottom: '10px',
  marginTop: '3px',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000'
};
LandingStyles['input_form'][view.DESKTOP] = {
  borderRadius: '2px',
  border: 'solid 1px rgba(0, 0, 0, 0.08)',
  padding: '10px 0px 10px 16px',
  width: '95%',
  marginBottom: '10px',
  marginTop: '3px',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000'
};

LandingStyles['become_an_oyo_text'] = {};
LandingStyles['become_an_oyo_text'][view.MOBILE] = {};
LandingStyles['become_an_oyo_text'][view.DESKTOP] = {
  opacity: '0.87',
  fontSize: '20px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.2',
  letterSpacing: 'normal',
  color: '#000000'
};

LandingStyles['form_container'] = {};
LandingStyles['form_container'][view.MOBILE] = {};
LandingStyles['form_container'][view.DESKTOP] = {
  ...vertCenterAbs,
  width: '400px',
  height: '513px',
  borderRadius: '8px',
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.1)',
  backgroundColor: '#ffffff',
  padding: '24px'
};
/////////////////////////////////////////////////////////////////////////////////
// Landing image

LandingStyles['mail_div'] = {};
LandingStyles['mail_div'][view.MOBILE] = {
  //top: '24px',
  //left: '68.5%',
  //fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#ffffff',
  width: '56px',
  zIndex: '1'
};

LandingStyles['mail_div'][view.DESKTOP] = {
  padding:'8px',
  fontSize: '15px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000',
  zIndex: '1'
};

LandingStyles['green_button'] = {};
commonStyle = {
  borderRadius: '4px',
  backgroundColor: 'rgb(26, 182, 79)',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: 'rgb(255, 255, 255)',
  lineHeight: '1.14',
  textTransform: 'uppercase',
  boxShadow: 'rgba(26, 182, 79, 0.2) 0px 4px 8px 0px'
};
LandingStyles['green_button'][view.MOBILE] = {
  ...commonStyle
};

LandingStyles['green_button'][view.DESKTOP] = {
  ...commonStyle,
  width: '90px',
  padding: '7px',
  marginTop: '-5px',
  textShadow: 'none'
};

LandingStyles['mail_phone_div'] = {};
LandingStyles['mail_phone_div'][view.MOBILE] = {
  width: 'auto',
  height: 'auto',
  position: 'absolute',
  display: 'flex',
  right: '0%',
  top: '24px'
};

LandingStyles['mail_phone_div'][view.DESKTOP] = {
  borderRadius:'6px',
  backgroundColor:'white'
};

LandingStyles['call_div'] = {};
LandingStyles['call_div'][view.MOBILE] = {
  //top: '24px',
  //left: '84.5%',
  // fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#ffffff',
  width: '55px',
  zIndex: '1'
};
LandingStyles['call_div'][view.DESKTOP] = {
  padding:'8px',
  fontSize: '15px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000',
  zIndex: '1'
  
};

LandingStyles['mail_icon_landing_image'] = {};
LandingStyles['mail_icon_landing_image'][view.MOBILE] = {
  width: '40px',
  height: '40px',
  // top:'16px',
  marginLeft: '8px',
  //marginRight:'8px',
  postion: 'absolute'
};
LandingStyles['mail_icon_landing_image'][view.DESKTOP] = {
  width: '18px',
  marginRight: '10px',
  height: '12px'
};
LandingStyles['circle_style'] = {};
LandingStyles['circle_style'][view.MOBILE] = {
  borderRadius: '50%',
  border: '1px solid white'
};
LandingStyles['circle_style'][view.DESKTOP] = {};

LandingStyles['call_icon_landing_image'] = {};
LandingStyles['call_icon_landing_image'][view.MOBILE] = {
  width: '40px',
  height: '40px',
  marginLeft: '6px'
};
LandingStyles['call_icon_landing_image'][view.DESKTOP] = {
  width: '16px',
  marginRight: '8px',
  height: '15px'
};
///working on it
LandingStyles['oyo_white'] = {};
LandingStyles['oyo_white'][view.MOBILE] = {
  position: 'absolute',
  top: '20px',
  //left:'16px',
  left: '3%',
  width: '94px',
  height: '40px',
  zIndex: '1'
};
LandingStyles['oyo_white'][view.DESKTOP] = {
  position: 'absolute',
  left: '62px',
  top: '32px',
  width: '94.9px',
  height: '44px',
  zIndex: '1'
};

LandingStyles['landing_parent'] = {};
LandingStyles['landing_parent'][view.MOBILE] = {
  position: 'relative',
  width: '100%'
  // overflow:'hidden'
};
LandingStyles['landing_parent'][view.DESKTOP] = {
  position: 'relative',
  overflow: 'hidden'
};

LandingStyles['mail_text_style'] = {};
LandingStyles['mail_text_style'][view.MOBILE] = {
  visibility: 'hidden',
  textShadow: '2px 2px #000000'
};
LandingStyles['mail_text_style'][view.DESKTOP] = {
  textShadow: '2px 2px #000000'
};

LandingStyles['call_text_style'] = {};
LandingStyles['call_text_style'][view.MOBILE] = {
  visibility: 'hidden',
  textShadow: '2px 2px #000000'
};
LandingStyles['call_text_style'][view.DESKTOP] = {
  textShadow: '2px 2px #000000'
};

LandingStyles['join_fastest_text'] = {};
LandingStyles['join_fastest_text'][view.MOBILE] = {
  ...horiCenterAbs,
  top: '30%',
  width: '324px',
  height: '60px',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  fontFamily: 'InterphaseMedium'
};
LandingStyles['join_fastest_text'][view.DESKTOP] = {
  ...centerAbs,
  transform: 'translateY(-50%) translateX(-600px)',
  fontSize: '50px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#ffffff',
  fontFamily: 'InterphaseMedium',
  width: '600px'
};

// Why Join Oyo?
// example of setting stype

//heading
LandingStyles['why_oyo_head'] = {};
LandingStyles['why_oyo_head'][view.MOBILE] = {
  position: 'relative',
  textAlign: 'center'
};
LandingStyles['why_oyo_head'][view.DESKTOP] = {
  // marginTop: '40px',
  textAlign: 'center'
};

LandingStyles['images_div_why_join'] = {};
LandingStyles['images_div_why_join'][view.MOBILE] = {
  overflowY: 'hidden',
  //width: '100%',
  display: 'flex'
};
LandingStyles['images_div_why_join'][view.DESKTOP] = {
  // marginBottom: '80px',
  display: 'flex'
};

LandingStyles['images_sub_div_why_join'] = {};
LandingStyles['images_sub_div_why_join'][view.MOBILE] = {
  // padding: '0px 0px 16px 8px',
  paddingRight: '10px',
  height: '100%',
  position: 'relative'
};
LandingStyles['images_sub_div_why_join'][view.DESKTOP] = {
  height: '345px',
  position: 'relative',
  width: '25%'
};

LandingStyles['bold_big_sub_head'] = {};
LandingStyles['bold_big_sub_head'][view.MOBILE] = {
  position: 'relative',
  marginLeft: '10%',
  marginRight: '10%',
  width: '80%',
  marginBottom: '32px',
  marginTop: '8px',
  height: '40px',
  opacity: '0.7',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};
LandingStyles['bold_big_sub_head'][view.DESKTOP] = {
  opacity: '0.7',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  marginTop: '10px',
  marginBottom: '48px'
};

LandingStyles['bold_big_head'] = {};
LandingStyles['bold_big_head'][view.MOBILE] = {
  position: 'realtive',
  width: '80%',
  marginLeft: '10%',
  marginRight: '10%',
  marginBottom: '8px',
  marginTop: '41px',
  opacity: '0.87',
  fontFamily: 'InterphaseBold',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};
LandingStyles['bold_big_head'][view.DESKTOP] = {
  opacity: '0.87',
  fontSize: '36px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  fontFamily: 'InterphaseBold'
};

// Oyo Stats styles
LandingStyles['oyo_stats_container'] = {};
LandingStyles['oyo_stats_container'][view.MOBILE] = {
  height: '134px',
  display: 'flex',
  color: '#555',
  width: '250%',
  marginTop: '40px'
};
LandingStyles['oyo_stats_container'][view.DESKTOP] = {
  height: '134px',
  display: 'flex',
  color: '#555'
};

LandingStyles['child_oyo_stats'] = {};
LandingStyles['child_oyo_stats'][view.MOBILE] = {
  width: '25%',
  position: 'relative'
};
LandingStyles['child_oyo_stats'][view.DESKTOP] = {
  borderRight: 'solid rgba(85, 85, 85, 0.1) 1px',
  borderBottom: 'solid rgba(85, 85, 85, 0.1) 1px',
  width: '25%',
  position: 'relative'
};

LandingStyles['child_oyo_stats_content'] = {};
LandingStyles['child_oyo_stats_content'][view.MOBILE] = {
  width: '165px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translateX(-50%) translateY(-50%)'
};
LandingStyles['child_oyo_stats_content'][view.DESKTOP] = {
  width: '165px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translateX(-50%) translateY(-50%)'
};

LandingStyles['child_oyo_stats_text_big'] = {};
LandingStyles['child_oyo_stats_text_big'][view.MOBILE] = {
  color: 'rgba(0, 0, 0, 0.54)',
  position: 'absolute',
  top: '0px',
  fontSize: '36px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.11',
  letterSpacing: 'normal',
  fontFamily: 'InterphaseMedium'
};
LandingStyles['child_oyo_stats_text_big'][view.DESKTOP] = {
  position: 'absolute',
  top: '0px',
  color: 'rgba(0, 0, 0, 0.54)',
  fontSize: '36px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.11',
  letterSpacing: 'normal',
  fontFamily: 'InterphaseMedium'
};

LandingStyles['child_oyo_stats_text_small'] = {};
LandingStyles['child_oyo_stats_text_small'][view.MOBILE] = {
  position: 'absolute',
  bottom: '0px',
  height: '24px',
  color: 'rgba(0, 0, 0, 0.54)',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal'
};
LandingStyles['child_oyo_stats_text_small'][view.DESKTOP] = {
  position: 'absolute',
  bottom: '0px',
  height: '24px',
  color: 'rgba(0, 0, 0, 0.54)',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  width: '125px'
};

LandingStyles['child_oyo_stats_image'] = {};
LandingStyles['child_oyo_stats_image'][view.MOBILE] = {
  width: '70px',
  height: '70px',
  opacity: '0.7',
  top: '32px',
  left: '145px',
  display: 'inline'
};
LandingStyles['child_oyo_stats_image'][view.DESKTOP] = {
  width: '70px',
  height: '70px',
  opacity: '0.7',
  top: '32px',
  left: '145px',
  display: 'inline'
};

LandingStyles['child_oyo_text_span'] = {};
LandingStyles['child_oyo_text_span'][view.MOBILE] = {
  position: 'absolute',
  width: '76px',
  top: '0px',
  height: '70px',
  marginLeft: '24px',
  opacity: '0.54'
};
LandingStyles['child_oyo_text_span'][view.DESKTOP] = {
  position: 'absolute',
  width: '76px',
  top: '0px',
  height: '70px',
  marginLeft: '24px',
  opacity: '0.54'
};

// OYO OS Module

LandingStyles['os_text_container'] = {};
LandingStyles['os_text_container'][view.DESKTOP] = {
  // ...horiCenterAbs,
  // left: '50%',
  // transform: 'translateX(-50%)',
  position: 'relative',
  marginTop: '80px'
  // marginBottom: '35px'
};
LandingStyles['os_text_container'][view.MOBILE] = {
  // ...horiCenterAbs,
  position: 'relative',
  top: '40px'
  //  marginTop:'40px'
};

LandingStyles['oyo_property_heading'] = {};

LandingStyles['oyo_property_heading'][view.DESKTOP] = {
  opacity: '0.87',
  fontSize: '36px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#000000'
};

LandingStyles['oyo_property_heading'][view.MOBILE] = {
  opacity: '0.87',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#000000'
};

LandingStyles['oyo_os_container'] = {};

LandingStyles['oyo_os_container'][view.DESKTOP] = {
  position: 'relative',
  width: '100%',
  // height: '673px',
  overflow: 'hidden',
  backgroundColor: '#f3f5f7'
};
//editing
LandingStyles['oyo_os_container'][view.MOBILE] = {
  position: 'relative',
  width: '100%',
  // height: '918px',
  backgroundColor: '#f3f5f7',
  overFlow: 'hidden'
};

LandingStyles['oyo_os_head1'] = {};

LandingStyles['oyo_os_head1'][view.DESKTOP] = {
  opacity: '0.87',
  fontSize: '36px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  fontFamily: 'InterphaseBold'
};

//editing
LandingStyles['oyo_os_head1'][view.MOBILE] = {
  width: '80%',
  marginLeft: '10%',
  marginBottom: '8px',
  height: 'auto',
  opacity: '0.87',
  fontSize: '24px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: 'normal',
  color: '#000000',
  textAlign: 'center',
  fontFamily: 'InterphaseBold'
};

LandingStyles['oyo_os_head2'] = {};
LandingStyles['oyo_os_head2'][view.DESKTOP] = {
  opacity: '0.7',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000',
  textAlign: 'center'
};

LandingStyles['oyo_os_head2'][view.MOBILE] = {
  width: '80%',
  marginLeft: '10%',
  height: '20px',
  opacity: '0.7',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  color: '#000000',
  textAlign: 'center'
};

LandingStyles['main_body_style'] = {};
LandingStyles['main_body_style'][view.DESKTOP] = {
  display: 'flex'
  // height:"inherit"
  // marginTop:'12%'
};

LandingStyles['left_body_style'] = {};
LandingStyles['left_body_style'][view.DESKTOP] = {
  flex: '45',
  marginTop: '3%',
  marginLeft: '5%',
  minWidth: '500px'
};

LandingStyles['right_body_style'] = {};
LandingStyles['right_body_style'][view.DESKTOP] = {
  // width: '755px',
  // right: '0px',
  // left:'29%',
  // bottom: '0px',
  // height: '526px',
  // position: 'absolute'
  flex: '55',
  position: 'relative',
  width: '100%',
  height: '100%'
};
LandingStyles['right_body_style'][view.MOBILE] = {
  //top: '130px',
  marginTop: '10px',
  // height: '263px',
  // width: '360px',
  position: 'relative'
  //  bottom:'0px'
};

LandingStyles['left_body_style'][view.MOBILE] = {
  position: 'relative',
  marginLeft: '0% 6%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center'
};

LandingStyles['left_body_style_flex_flow'] = {};

LandingStyles['left_body_style_flex_flow'][view.MOBILE] = {
  position: 'relative',
  margin: '0% 6%',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  flexDirection: 'column'
};

LandingStyles['main_body_style'][view.MOBILE] = {
  marginTop: '80px',
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center'
};

LandingStyles['left_text_style'] = {};
LandingStyles['left_text_style'][view.DESKTOP] = {
  marginTop: '10px'
};
LandingStyles['left_text_style'][view.MOBILE] = {
  //width: '90%',
  display: 'flex',
  marginRight: '20px'
};
LandingStyles['os_bullet_style'] = {};
LandingStyles['os_bullet_style'][view.DESKTOP] = {
  height: '12px',
  width: '12px',
  position: 'relative'
};

LandingStyles['os_bullet_style'][view.MOBILE] = {
  marginTop: '4px',
  height: '12px',
  width: '12px',
  left: '0px',
  position: 'relative'
};
LandingStyles['os_image_style'] = {};
LandingStyles['os_image_style'][view.DESKTOP] = {
  height: '100%',
  // left: '0px',
  // right: '48px',
  // bottom: '-3.6%',
  // position: 'absolute',
  // position:'relative',
  // margin: 'auto',
  width: '100%'
};

LandingStyles['os_image_style'][view.MOBILE] = {
  // height: '100%',
  width: '100%',
  left: '0',
  right: '0'
  // bottom: '-8px',
  // position: 'absolute'
};

LandingStyles['os_logo_style'] = {};
LandingStyles['os_logo_style'][view.DESKTOP] = {
  height: '36px',
  width: '65px'
  // top: '-40px',
  // left: '0px',
  // position: 'absolute'
};

LandingStyles['os_logo_style'][view.MOBILE] = {
  marginBottom: '24.7px',
  height: '24px',
  width: '42px',
  top: '10px',
  left: '6px',
  position: 'relative'
};

LandingStyles['oyo_logo_style'] = {};
LandingStyles['oyo_logo_style'][view.DESKTOP] = {
  height: '34px',
  width: '44px',
  top: '0px',
  left: '0px',
  position: 'relative'
};

LandingStyles['oyo_logo_style'][view.MOBILE] = {
  height: '24px',
  width: '33px',
  // top: '10px',
  // left: '0px',
  position: 'relative',
  marginBottom: '6px',
  marginLeft: '6px',
  marginTop: '20px'
};
LandingStyles['os_content2'] = {};
LandingStyles['os_content2'][view.MOBILE] = {
  position: 'relative'
  // top: '20px'
};
LandingStyles['os_content2'][view.DESKTOP] = {
  position: 'relative',
  top: '40px'
};

LandingStyles['play_style'] = {};
LandingStyles['play_style'][view.DESKTOP] = {
  height: '58px',
  width: '58px',
  //top: '450px',
  // right: '276px',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  margin: 'auto',
  position: 'absolute'
};

LandingStyles['play_style'][view.MOBILE] = {
  height: '41.4px',
  width: '41.4px',
  // top: '770.3px',
  // left: '214.3px',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
  margin: 'auto',
  // left: '58.90%',
  position: 'absolute'
};

LandingStyles['button_background_style'] = {};
LandingStyles['button_background_style'][view.DESKTOP] = {
  height: '140px',
  width: '140px',
  //top: '409px',
  // right: '235px',
  // left: '53.9%',
  left: '0',
  right: '0',
  bottom: '0',
  top: '0',
  margin: 'auto',
  position: 'absolute'
};

LandingStyles['button_background_style'][view.MOBILE] = {
  height: '81.4px',
  width: '81.4px',
  // top: '750.3px',
  // left: '194.3px',
  position: 'absolute',
  left: '0',
  right: '0',
  bottom: '0',
  top: '0',
  margin: 'auto'
};

LandingStyles['play_container_style'] = {};
LandingStyles['play_container_style'][view.DESKTOP] = {
  height: '140px',
  width: '140px',
  ...centerAbs,
  transform: 'translateY(-42%)'
};
LandingStyles['play_container_style'][view.MOBILE] = {};

LandingStyles['oyo_os_body'] = {};
LandingStyles['oyo_os_body'][view.DESKTOP] = {
  marginLeft: '3px',
  display: 'inline',
  opacity: '0.7',
  fontSize: '16px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  position: 'relative',
  marginLeft: '10px'
};

LandingStyles['oyo_os_body'][view.MOBILE] = {
  marginLeft: '3px',
  opacity: '0.7',
  display: 'inline',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  color: '#000000',
  position: 'relative',
  marginLeft: '10px',
  marginBottom: '8px'
  //top: '30px'
};

// Partner with Oyo

LandingStyles['steps_images_container'] = {};
LandingStyles['steps_images_container'][view.MOBILE] = {
  height: '277px',
  overflowX: 'scroll',
  display: 'flex'
};
LandingStyles['steps_images_container'][view.DESKTOP] = {
  ...horiCenterAbs,
  height: '180px',
  display: 'flex',
  width: '930px'
};

LandingStyles['steps_images_sub_container'] = {};
LandingStyles['steps_images_sub_container'][view.MOBILE] = {
  width: '100%'
};
LandingStyles['steps_images_sub_container'][view.DESKTOP] = {
  width: '100%',
  height: '180px',
  opacity: '0.87',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#231815'
};
LandingStyles['steps_style'] = {};
LandingStyles['steps_style'][view.MOBILE] = {
  marginTop: '21px',
  height: '24px',
  opacity: '0.87',
  fontFamily: 'InterphaseMedium',
  fontSize: '16px',
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#231815'
};
LandingStyles['steps_style'][view.DESKTOP] = {};

LandingStyles['steps_image'] = {};
LandingStyles['steps_image'][view.MOBILE] = {
  marginLeft: '85px',
  marginRight: '85px',
  width: '110px',
  height: '110px'
};
LandingStyles['steps_image'][view.DESKTOP] = {
  width: '130px',
  height: '130px',
  marginBottom: '8px'
};

LandingStyles['partner_number_img'] = {};
LandingStyles['partner_number_img'][view.MOBILE] = {
  position: 'relative',
  top: '10px',
  left: '7px',
  marginTop: '12px',
  height: '33px'
};
LandingStyles['partner_number_img'][view.DESKTOP] = {
  height: '33px',
  width: '33px',
  position: 'relative',
  top: '10px',
  left: '5px'
};

LandingStyles['steps_image_separator'] = {};
LandingStyles['steps_image_separator'][view.MOBILE] = {};
LandingStyles['steps_image_separator'][view.DESKTOP] = {
  width: '281px'
};

LandingStyles['steps_text_container'] = {};
LandingStyles['steps_text_container'][view.MOBILE] = {};
LandingStyles['steps_text_container'][view.DESKTOP] = {
  ...horiCenterAbs,
  width: '1120px',
  bottom: '60px',
  display: 'flex'
};

LandingStyles['partner_text_content'] = {};
LandingStyles['partner_text_content'][view.MOBILE] = {
  marginTop: '12px',
  marginBottom: '24px',
  width: '100%',
  height: '40px',
  opacity: '0.7',
  fontSize: '14px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#000000'
};
LandingStyles['partner_text_content'][view.DESKTOP] = {
  width: '310px'
};

// People check in component
LandingStyles['no_of_people_parent'] = {};
LandingStyles['no_of_people_parent'][view.MOBILE] = {
  ...centerAbs,
  transform: 'translateY(-50%) translateX(-50%)',
  width: '312px',
  height: '248px',
  borderRadius: '2px',
  boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.5)',
  backgroundColor: '#ffffff',
  overflow: 'hidden'
};
LandingStyles['no_of_people_parent'][view.DESKTOP] = {
  ...centerAbs,
  transform: 'translateY(-50%) translateX(-600px)',
  width: '367px',
  height: '286px',
  borderRadius: '2px',
  boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.5)',
  backgroundColor: '#ffffff',
  overflow: 'hidden'
};

LandingStyles['no_of_people_text_container'] = {};
LandingStyles['no_of_people_text_container'][view.MOBILE] = {
  position: 'absolute',
  top: '32px',
  left: '32px',
  right: '32px',
  height: '67px',
  borderBottom: 'solid #ccc 0.5px',
  display: 'flex'
};
LandingStyles['no_of_people_text_container'][view.DESKTOP] = {
  position: 'absolute',
  top: '32px',
  left: '32px',
  right: '32px',
  height: '80px',
  borderBottom: 'solid #ccc 0.5px',
  display: 'flex'
};

LandingStyles['no_of_people'] = {};
LandingStyles['no_of_people'][view.MOBILE] = {
  opacity: '0.87',
  fontSize: '48px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  color: '#231815',
  width: '55px',
  marginTop: '-2px',
  fontFamily: 'InterphaseBold'
};
LandingStyles['no_of_people'][view.DESKTOP] = {
  opacity: '0.87',
  fontSize: '60px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1',
  letterSpacing: 'normal',
  color: '#231815',
  width: '55px',
  fontFamily: 'InterphaseBold'
};

LandingStyles['no_of_people_content'] = {};
LandingStyles['no_of_people_content'][view.MOBILE] = {
  opacity: '0.87',
  fontSize: '14px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  width: '230px',
  fontFamily: 'InterphaseMedium'
};
LandingStyles['no_of_people_content'][view.DESKTOP] = {
  opacity: '0.87',
  fontSize: '16px',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  color: '#000000',
  width: '230px',
  fontFamily: 'InterphaseMedium'
};

LandingStyles['no_of_people_lower'] = {};
LandingStyles['no_of_people_lower'][view.MOBILE] = {
  position: 'absolute',
  bottom: '32px',
  left: '32px',
  right: '32px'
};
LandingStyles['no_of_people_lower'][view.DESKTOP] = {
  position: 'absolute',
  bottom: '32px',
  left: '32px',
  right: '32px'
};

LandingStyles['no_of_people_lower_text'] = {};
LandingStyles['no_of_people_lower_text'][view.MOBILE] = {
  fontSize: '14px',
  marginTop: '15.5px'
};
LandingStyles['no_of_people_lower_text'][view.DESKTOP] = {};

LandingStyles['no_of_people_lower_btn'] = {};
LandingStyles['no_of_people_lower_btn'][view.MOBILE] = {
  width: '248px',
  height: '40px',
  borderRadius: '2px',
  border: '0',
  boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
  backgroundColor: '#1ab64f',
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  marginTop: '16px'
};
LandingStyles['no_of_people_lower_btn'][view.DESKTOP] = {
  width: '303px',
  height: '48px',
  borderRadius: '2px',
  border: '0',
  boxShadow: '0 4px 8px 0 rgba(26, 182, 79, 0.2)',
  backgroundColor: '#1ab64f',
  fontSize: '16px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: 'normal',
  textAlign: 'center',
  color: '#ffffff',
  marginTop: '24px'
};

// video banner
LandingStyles['video_banner'] = {};
LandingStyles['video_banner'][view.MOBILE] = {
  backgroundColor: '#f3f5f7',
  paddingBottom: '40px',
  paddingTop: '1px'
};
LandingStyles['video_banner'][view.DESKTOP] = {
  textAlign: 'center',
  backgroundColor: '#f3f5f7',
  paddingBottom: '80px',
  paddingTop: '80px'
};

LandingStyles['video_banner_videos'] = {};
LandingStyles['video_banner_videos'][view.DESKTOP] = {
  // justifyContent: 'center',
  display: 'flex',
  justifyContent: 'center',
  overflowX: 'scroll'
};
LandingStyles['video_banner_videos'][view.MOBILE] = {
  display: 'flex',
  overflowX: 'scroll',
  justifyContent: 'space-between'
};

//terms and conditions
LandingStyles['sidebar_main_container'] = {};
LandingStyles['sidebar_main_container'][view.DESKTOP] = {
  // flex: '32%',
  border: 'solid',
  borderColor: 'red',
  flexDirection: 'column',
  display: 'block',
  paddingLeft: '0px',
  paddingTop: '70px',
  // height: 'auto',
  height: '1200px',
  overflowY: 'scroll',
  width: '360px',
  fontFamily: 'OpenSans',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '20px',
  color: 'rgba(0,0,0,0.87)',
  textShadow: 'none',
  backgroundImage: 'linear-gradient(161deg,#d11450,#ee3f25 95%,#ef4123)'
};
LandingStyles['sidebar_main_container'][view.MOBILE] = {
  display: 'none'
};

LandingStyles['sidebar_heading'] = {};
LandingStyles['sidebar_heading'][view.DESKTOP] = {
  color: '#fff',
  fontSize: '28px',
  fontWeight: '700',
  fontFamily: 'Open Sans',
  lineHeight: 'normal',
  margin: '100px 0 60px 20px',
  position: 'relative',
  textAlign: 'left',
  width: '300px',
  paddingLeft: '24px',
  margin: '50px 0 60px 20px',
  display: 'block'
};
LandingStyles['sidebar_heading'][view.MOBILE] = {
  color: '#fff',
  fontSize: '28px',
  fontWeight: '700',
  fontFamily: 'Open Sans',
  lineHeight: 'normal',
  margin: '100px 0 60px 20px',
  position: 'relative',
  textAlign: 'left',
  width: '300px',
  paddingLeft: '24px',
  margin: '100px 0 60px 20px',
  display: 'block'
};

LandingStyles['sidebar_heading_2'] = {};
LandingStyles['sidebar_heading_2'][view.DESKTOP] = {
  backgroundColor: 'rgba(0,0,0,.1)',
  opacity: '0.87',
  borderLeft: '6px solid #fff',
  fontSize: '16px',
  fontWeight: '600',
  fontFamily: 'Open Sans',
  lineHeight: '3.4',
  textAlign: 'left',
  color: '#fff',
  paddingLeft: '23px',
  boxSizing: 'border-box',
  display: 'block',
  boxSizing: 'border-box',
  // background:'#b3d4fc',
  textShadow: 'none'
};
LandingStyles['sidebar_heading_2'][view.MOBILE] = {
  backgroundColor: 'rgba(0,0,0,.1)',
  opacity: '0.87',
  borderLeft: '6px solid #fff',
  fontSize: '16px',
  fontWeight: '600',
  fontFamily: 'Open Sans',
  lineHeight: '3.4',
  textAlign: 'left',
  color: '#fff',
  paddingLeft: '23px',
  boxSizing: 'border-box',
  display: 'block',
  boxSizing: 'border-box',
  // background:'#b3d4fc',
  textShadow: 'none'
};

LandingStyles['mainbody_container_style'] = {};
LandingStyles['mainbody_container_style'][view.DESKTOP] = {
  scrollBehavior: 'smooth',
  flex: '68%',
  // border:'solid',
  // borderColor:'yellow',
  flexDirection: 'column',
  overflowY: 'auto',
  height: '1240px',
  // padding: '17% 11% 0',
  // paddingLeft: '35%',
  fontFamily: 'Open Sans',
  textAlign: 'justify',
  fontSize: '14px',
  fontWeight: '400',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: '1.57',
  letterSpacing: 'normal',
  color: '#000'
};
LandingStyles['mainbody_container_style'][view.MOBILE] = {
  scrollBehavior: 'smooth',
  flex: '65%',
  // border:'solid',
  // borderColor:'yellow',
  flexDirection: 'column',
  overflowY: 'auto',
  height: '1138px',
  padding: '17% 11% 0',
  // paddingLeft: '35%',
  fontFamily: 'Open Sans',
  textAlign: 'justify',
  fontSize: '14px',
  fontWeight: '400',
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: '1.57',
  letterSpacing: 'normal',
  color: '#000'
};

LandingStyles['main_heading_1'] = {};
LandingStyles['main_heading_1'][view.DESKTOP] = {
  fontFamily: 'Open Sans',
  opacity: '0.7',
  marginLeft: '-8%',
  fontSize: '16px',
  fontWeight: '600',
  paddingBottom: '7%',
  textAlign: 'justify',
  fontSytle: 'normal',
  letterSpacing: 'normal',
  lineHeight: '1.57'
};
LandingStyles['main_heading_1'][view.MOBILE] = {
  // width:'100%',
  // height:'30px',

  color: '#fff',
  padding: '23px',
  fontSize: '14px',
  backgroundColor: 'rgba(255,255,255,.04)',
  border: '1px solid #e27676',
  margin: '-1px',
  display: 'block',
  opacity: '0.7',
  fontWeight: '600',
  textAlign: 'center',
  textAlign: 'justify',
  backgroundImage: 'linear-gradient(128deg,#d11450,#ee3f25 95%,#ef4123)'
};

LandingStyles['main_heading_2'] = {};
LandingStyles['main_heading_2'][view.DESKTOP] = {
  boxSizing: 'border-box',
  fontWeight: 'bold',
  fontSize: '14px',
  lineHeight: '1.57',
  color: '#000',
  fontFamily: 'Open Sans',
  fontStyle: 'normal'
};
LandingStyles['main_heading_2'][view.MOBILE] = {
  boxSizing: 'border-box',
  fontWeight: 'bold',
  fontSize: '14px',
  lineHeight: '1.57',
  color: '#000',
  fontFamily: 'Open Sans',
  fontStyle: 'normal'
};

LandingStyles['content_tnc_container'] = {};
LandingStyles['content_tnc_container'][view.DESKTOP] = {
  padding: '12% 14% 0',
  fontFamily: 'Open Sans'
};
LandingStyles['content_tnc_container'][view.MOBILE] = {
  fontFamily: 'Open Sans'
};

LandingStyles['message_modal'] = {};
commonStyle = {
  backgroundColor: 'white',
  ...centerAbs
};
LandingStyles['message_modal'][view.DESKTOP] = {
  ...commonStyle,
  width: '65%',
  height: '330px',
  maxWidth:'450px'
};
LandingStyles['message_modal'][view.MOBILE] = {
  ...commonStyle,
  width: '75%',
  height: '220px'
};

key = 'success_icon';
LandingStyles[key] = {};
commonStyle = {};
LandingStyles[key][view.DESKTOP] = {
  ...commonStyle,
  marginTop: '38px',
  width: '100px',
  height: '100px'
};
LandingStyles[key][view.MOBILE] = {
  ...commonStyle,
  marginTop: '33px',
  width: '80px',
  height: '80px'
};

key = 'modal_message';
LandingStyles[key] = {};
commonStyle = {
  marginTop: '10px',
  width: '80%',
  marginLeft: '10%'
};
LandingStyles[key][view.DESKTOP] = {
  ...commonStyle,
  marginTop: '50px'
};
LandingStyles[key][view.MOBILE] = {
  ...commonStyle
};

LandingStyles['dialog_header'] = makeStyle([rowCenter, {
  justifyContent: 'space-between', padding: '10px 10px 10px 22px'
}], { padding: '20px 20px 20px 32px' });

LandingStyles['dialog_title'] = makeStyle([h6, black, { letterSpacing: '-0.35px' }]);

LandingStyles['dialog_content'] = makeStyle([subTitle1, bold, { padding: '0 36px 32px 32px', color: '#035ed2', letterSpacing: '-0.35px' }]);

LandingStyles['contact_border_circle'] = makeStyle({
  border: '1px solid',
  borderRadius: '50%',
  width: '38px',
  height: '38px',
  textAlign: 'center'
});

LandingStyles['contact_icon'] = makeStyle({ marginTop: '9px', opacity: '0.75' });

LandingStyles['limited_time_offer'] = makeStyle({fontWeight:1000,marginTop:'auto',color:'black'},{fontSize:28},view.MOBILE,{fontSize:20});

LandingStyles['timer_parent'] = makeStyle({
  zIndex:5000,
  position:'absolute',
  backgroundColor:'white',display:'flex',alignItems:'center',flexDirection:'column',borderRadius:12,...centerAbs
},{
  width:'290px',height:'120px',top:'45%',
  left:'45%'
},view.MOBILE,{width:'220px',height:'90px',top:'53%'});

LandingStyles['limited_offer_box'] = makeStyle({},{height:56,width:56,fontSize:24},view.MOBILE,{height:40,width:40,fontSize:16});

LandingStyles['carousel_item'] = makeStyle({
  width: '100%', minHeight: 400, ...rowCenter, justifyContent: 'center',
  padding: 24, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center'
});

LandingStyles['carousel_text'] = makeStyle([h5, {
  maxWidth: 600,
  padding: 32,
  background: '#ffffff0d',
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
  backdropFilter: 'blur(4px)',
  borderRadius: 10,
  border: '1px solid rgba(255, 255, 255, 0.18)',
  textAlign: 'center',
  color: 'white'
}]);

LandingStyles['cta_button'] = makeStyle({
  borderRadius: 6,
  backgroundColor: 'var(--theme-color)',
  textAlign: 'center',
  color: 'white',
  padding: '8px 24px',
  margin: '24px auto 0',
  display: 'flex',
  alignItems: 'center',
  ...button,
});

LandingStyles['tab_cards'] = makeStyle({
  width: '100%',
  display: 'flex',
  overflow: 'auto',
  position: 'relative',
  scrollSnapType: 'x mandatory',
  boxSizing: 'border-box',
});

LandingStyles['tab_cards_padding'] = makeStyle({ minWidth: '5%', flex: 1 });

LandingStyles['tab_card'] = makeStyle({
  borderRadius: 8,
  border: 'solid 0.5px rgba(0, 0, 0, 0.1)',
  minWidth: '60%',
  scrollSnapAlign: 'center',
  margin: '8px 4px',
  boxShadow: '5px 5px rgba(157, 157, 157, 0.14)',
});

LandingStyles['mobile_carousel_title'] = makeStyle({ color: 'var(--theme-color)', ...h6});
LandingStyles['mobile_carousel_description'] = makeStyle({ ...subTitle1, color: '#2B3642' });
LandingStyles['oyo_360_logo'] = makeStyle({},{ paddingTop : '20%'},{},{ paddingTop : '1em' });
LandingStyles['landing_image_header'] = makeStyle({
  position: 'absolute',
  top: '20px',
  right: '0px',
  color: 'white',
  width: '500px',
  zIndex: '100',
  display: 'flex'
});
export default LandingStyles;
